import { Languages } from "lucide-react";
import { useT, LANGS } from "../context/LanguageContext";

export function LanguageSwitcher({ className = "" }) {
  const { lang, setLang } = useT();
  return (
    <div className={`inline-flex items-center gap-1 ${className}`} data-testid="language-switcher" title="Choose language">
      <Languages className="w-4 h-4 text-muted2 hidden sm:block" />
      <div className="inline-flex items-center rounded-full border border-line overflow-hidden text-xs font-bold">
        {LANGS.map((l) => (
          <button key={l.code} onClick={() => setLang(l.code)} data-testid={`lang-${l.code}`}
            aria-pressed={lang === l.code} title={l.full}
            className={`px-2.5 py-1 transition-colors ${lang === l.code ? "bg-clinical text-white" : "bg-white text-muted2 hover:text-ink"}`}>
            {l.label}
          </button>
        ))}
      </div>
    </div>
  );
}
